<template>
  <div class="detail-header">
    <div class="container">
      <div class="row">
        <div class="col-4 logo">
          <img src="../../assets/logo.png">
        </div>
        <div class="col-8 header-right">
          <div class="row">
            <div class="row two-link">
              <div @click="openVisitList" class="invite" v-if="isDetailPage">
                <i class="iconfont icon-invite-line"></i><span>{{$t('InvitationList')}}</span>
              </div>
              <div class="invite" v-else>
                <router-link :to="'/external/detailIndex/' + trainingId + '/0?inviteList=true'">
                  <i class="iconfont icon-invite-line"></i><span>{{$t('InvitationList')}}</span>
                </router-link>
              </div>
              <div class="training">
                <router-link :to="'/external/training/' + trainingId + '/0'">
                  <i class="iconfont icon-training-line"></i><span>{{$t('TrainingList')}}</span>
                </router-link>
              </div>
              <div class="application" v-if="this.memberRole === '2'">
                <router-link :to="'/external/carrier-new-application/' + trainingId + '/0'">
                  <i class="iconfont icon-add"></i><span>{{$t('NewApplication')}}</span>
                </router-link>
              </div>
              <div class="guide">
                <router-link :to="`/external/guide/${trainingId}`">
                  <i class="iconfont icon-lesson"></i><span>{{$t('OperationGuide')}}</span>
                </router-link>
              </div>
            </div>
            <div class="logo-out">
              <span @click="showLoginOut = !showLoginOut" class="phoneNumber" v-if="this.phoneNumber">{{this.phoneNumber}}<i></i></span>
              <transition name="slide-fade">
                <div class="language-group logOut" v-show="this.showLoginOut" @click="logout">
                  <label class="control-label">
                    <input id="login-out" name="login-out" type="radio" :value="$t('Logout')" v-model="loginOut" @click="logout">
                    <label for="login-out"><img src="../../assets/images/tuichu.png">{{$t('Logout')}}</label>
                  </label>
                </div>
              </transition>
            </div>
            <div class="select-language-wrapper">
              <selectLanguage
              :isShow="true"
              :isExternal="true"
              :userType="2"
              :url="setlanguageExternal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  getOverviewInfo, getInvitationInfo, getInvitationSchedule, getRejectReasons, materialReview, checkPassOrReject, sendRemind, goodsListCheckPassOrReject,
  getInvitationInfoForEdit, getCurrentAccount
} from '@/utils/api';
import { checkNested } from '@/utils/utils';
import { setupLang } from '@/locales';
import { setLanguage } from '@/utils/api';
import myAuth from '@/utils/auth';
import selectLanguage from '@/components/selectLanguage.vue';
import { API } from '@/config/config';
export default {
  name: 'InviteDetail',
  props: {
    trainingId: String,
    isDetailPage: Boolean,
    phoneOremailShow: String,
  },
  components: {
    selectLanguage,
  },
  data() {
    return {
      setlanguageExternal: API.setlanguageExternal,
      showLanguage: false,
      locale: window.localStorage.getItem('localeLanguage'),
      phone: '',
      showOther: false,
      scrolled: false,
      inviteData: {},
      userType: 'warehouse',
      isTicketOwner: false,
      showPopup: false,
      modalTip: false,
      modalTipText: '',
      textareaAll: '',
      approverList: [],
      ccNameList: '',
      gmListShow: false,
      gmList: [],
      visitReason: false,
      isOwner: false,
      isCheckOwner: false,
      lessonList: '',
      routId: 0,
      showCheckPopup: false,
      goodsListId: '',
      textareaCheckDetail: '',
      selectReason: this.$t('chooseTheReason'),
      checkList: [],
      visitorData: [],
      visitorListArray: [],
      progress: [],
      RejectType: [],
      DeleteText: '',
      showVisitorHouse: true,
      newWareHouseShow: false,
      showComfirmDelete: false,
      deleteInvitationId: '',
      inviteGoodsList: [],
      goodsImages: [],
      currentGoods: {},
      approverId: '',
      isGoodsListChecker: false,
      lookImgs: false,
      // modify invite
      isLoading: false,
      isModifyInviteShow: false,
      inviteInfo: null,
      photoSwipeModal: false,
      showLoginOut: false,
      loginOut: '',
      phoneNumber: '',
      memberRole: '',
    };
  },
  created() {
    getCurrentAccount().then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        this.phoneNumber = res.data.content.model;
      }
    });
    this.memberRole = myAuth.getLocalUserRole();
  },
  methods: {
    handleScroll() {
      // console.log(this.$refs.detail);
      if (document.documentElement.clientHeight < document.body.clientHeight + 1) {
        this.scrolled = this.$refs.detail.scrollTop != 0;
      }
    },
    loadData(data) {
      // console.log(data);
      this.inviteData = data;
      if (this.inviteData.lessonName) {
        const lessonName = this.inviteData.lessonName;
        this.lessonList = lessonName.join('/');
      }
    },
    onLogoOut() {

    },
    changeStatus(status, checkList) {
      this.showPopup = status;
      this.checkList = checkList;
      // console.log(checkList);
    },
    popupTipModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    popupGmModal(status, txt) {
      this.showPopup = status;
    },
    selectVal(e) {
      const getValue = e.target.value;
      const getIndex = e.target.tab;
      if (this.textareaAll.indexOf(getValue) != -1 || getValue.indexOf(this.$t('choose')) != -1) {
        this.textareaAll = `${this.textareaAll}`;
      } else {
        this.textareaAll = `${this.textareaAll + getValue},`;
      }
    },
    commitReason() {
      if (this.textareaAll != '' || this.selectReason != this.$t('chooseTheReason')) {
        this.textareaAll = this.textareaAll.substring(0, this.textareaAll.lastIndexOf(','));
        let getReason = {};
        if (this.textareaAll === '') {
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.selectReason,
          };
        } else {
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.textareaAll,
          };
        }
        // console.log(getReason);
        materialReview(getReason).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.model;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('chooseTheReason');
      }
    },
    commitAllReason() {
      if (this.textareaAll != '') {
        const getReason = {
          id: this.routId,
          isPass: false,
          reason: this.textareaAll,
        };
        checkPassOrReject(getReason).then((res) => {
          if (res.data.content.status === 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    deleteInvite() {
      const invitationId = this.routId;
      if (invitationId) {
        this.goodsListId = '';
        this.deleteInvitationId = 'deleteInvitationId';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteInvitationId',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    closeNewWarehouse(status) {
      this.newWareHouseShow = status;
    },
    closeModal(status) {
      this.showComfirmDelete = status;
    },
    approveAllListModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    remindApproval(e) {
      const ApproverId = e.target.dataset.value;
      const statusId = e.target.dataset.status;
      if (statusId == 1) {
        this.deleteInvitationId = 'remindApproval';
        this.approverId = ApproverId;
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'remindApproval',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      } else {
        sendRemind(ApproverId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      }
    },
    deleteCheckDetail(e) {
      const GoodsListId = e.target.dataset.value;
      this.invitationId = this.routId;
      this.goodsListId = GoodsListId;
      if (this.invitationId && this.goodsListId) {
        this.deleteInvitationId = 'deleteCheckGoods';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteCheckGoods',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    rejectCheckDetail(e) {
      if (this.inviteGoodsList.length) {
        this.showCheckPopup = true;
        this.goodsListId = e.target.dataset.value;
      }
    },
    commitCheckReason() {
      // console.log(this.goodsListId);
      const goodsListId = this.goodsListId;
      const InvitationId = this.routId;
      if (this.textareaCheckDetail != '') {
        const getGoodObj = {
          goodsListId,
          ticketId: InvitationId,
          isPass: false,
          reason: this.textareaCheckDetail,
        };
        goodsListCheckPassOrReject(getGoodObj).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    agreeCheckDetail(e) {
      const goodsListId = e.target.dataset.value;
      // console.log(e);
      // console.log(goodsListId);
      const InvitationId = this.routId;
      const getGoodObj = {
        goodsListId,
        ticketId: InvitationId,
        isPass: true,
        reason: '',
      };
      goodsListCheckPassOrReject(getGoodObj).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.status == 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        }
      });
    },
    closeCheckModal() {
      this.showCheckPopup = false;
      this.textareaCheckDetail = '';
    },
    showLookImgs(status) {
      this.lookImgs = status;
    },
    modifyInvite() {
      this.isModifyInviteShow = true;
      getInvitationInfoForEdit(this.routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          this.inviteInfo = res.data.content.model;
        }
      });
    },
    // TODO: this event's name is quite strange
    handleGetMessage() {
      this.isModifyInviteShow = false;
    },
    closePhoto() {
      this.photoSwipeModal = false;
    },
    openVisitList() {
      this.$emit('changeVisitListStatus',true);
    },
    logout() {
      myAuth.logoutExternal();
    }
  }
};
</script>
<style lang="scss">
@import "../../scss/variables.scss";
.detail-header {
  position: relative;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
  .row {
    height: 56px;
    align-items: center;
    margin: 0;
    .header-right {
      padding: 0;
      & > .row {
        float: right;
        margin: 0;
        margin-right: 8px;
      }
      .two-link {
        display: flex;
        margin-right: 50px;
        line-height: 56px;
        & > div {
          margin-right: 29px;
        }
        & > div:last-child {
          margin-right: 0;
        }
        div {
          cursor: pointer;
        }
        span {
          font-size: 14px;
          color: #4a4a4a; 
        }
        i {
          color: #4a4a4a; 
        }
        img {
          margin-right: 5px;
        }
        a {
          display: block;
          &:hover {
            text-decoration: none;
          }
        }
        @include respond-to('sm-max') {
          display: none;
        }
        @include respond-to('ml') {
          display: none;
        }
      }
    }
    .logo {
      img {
        width: 30%;
        height: 35%;
        float: left;
        padding: 0;
        @include respond-to('xs') {
          width: 88%;
          height: auto;
        }
        @include respond-to('sm') {
          width: 75%;
          height: auto;
        }
        @include respond-to('md') {
           width: 35%;
           height: auto;
        }
        @include respond-to('lg') {
           width: 28%;
           height: auto;
        }
      }
    }
    .select-language-wrapper,
    .logo-out {
      position: relative;
      text-align: right;
      span {
       color: #4a4a4a;
       display: inline-block;
       font-size: 14px;
       i {
         display: inline-block;
         position: relative;
         top: -1px;
         width: 0;
         height: 0;
         border-style: solid;
         margin-left: 5px;
         border-width: 5px 4px 0 4px;
         border-color: #000 transparent transparent transparent;
       }
      }
    }
    .logo-out {
      position: relative;
      height: 24px;
      margin-right: 12px;
    }
    .language-group,
    .logOut {
      position: absolute;
      z-index: 99;
      padding: 15px 20px;
      text-align: left;
      background: #fff;
      right: 0;
      width: 96px;
      font-size: 14px;
      color: #929292;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
      top: 26px;
      label {
       line-height: 1;
       margin: 0;
       & + label {
         margin-top: 15px;
       }
      }
      input {
       display: none;
       &:checked + label {
         color: #e42029
       }
      }
    }
    .logOut {
      padding: 5px 5px;
      text-align: center;
    }
  }
  .iconfont {
    font-size: 14px;
    padding-right: 5px;
  }
}
.phoneNumber {
  text-overflow: ellipsis;
  width: 101px;
  overflow: hidden;
  position: relative;
  text-align: left;
  vertical-align: middle;
  & > i {
    position: absolute !important;
    top: 9px !important;
    right: 0 !important;
  }
}
.btn {
  &:focus,
  &:hover {
    box-shadow: none;
  }
}
.btn-default {
  border: 1px solid #929292;
  color: #9b9b9b;
}
.btn-red {
  color: #e42029;
  border: 1px solid #e42029;
}
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.invite-detail {
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  .header {
    height: auto;
    background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
    position: relative;
    z-index: 9;
    color: #fff;
    font-size: 13px;
    border-radius: 0;
    padding-bottom: 40px;
    &.posiFix {
      z-index: 11;
    }
    &.operationDele {
      padding-bottom: 30px;
    }
    .header-inner {
      padding: 15px;
      position: relative;
      z-index: 9;
      padding-right: 0;
      .top {
        & > div:last-child {
          text-align: right;
          padding-right: 30px;
        }
      }
      .posiFix {
        position: fixed;
        top: 0;
        z-index: 11;
        width: 100%;
        padding: 10px 0;
        background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
        align-items: center;
      }
    }
    .title {
      font-size: 16px;
      margin-bottom: 15px;
      font-weight: bold;
    }
    &:before {
      content: '';
      width: 110px;
      height: 110px;
      border-radius: 0 0 0 110px;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      border-left: 30px solid #fff;
      border-bottom: 30px solid #fff;
      opacity: 0.12;
    }
    .status-send-msg {
      .status {
        font-size: 13px;
        i {
          margin-right: 5px;
          font-size: 13px;
        }
      }
      .send-msg {
        font-size: 12px;
        text-align: right;
        span {
          border-bottom: 1px solid #fff;
        }
      }
    }
    .approver-copier {
      margin: 0;
      & > div:first-child {
        width: 130px;
      }
      .approver {
        padding: 0;
        span {
          border: 1px solid #fff;
          margin-left: 10px;
          padding: 1px;
          font-size: 11px;
          i {
            font-size: 12px;
          }
        }
      }
      .remind {
        text-align: right;
        span {
          cursor: pointer;
          padding-bottom: 2px;
          border-bottom: 1px solid #fff;
          font-size: 11px;
        }
      }
    }
    .member {
      & > div {
        padding: 0 15px;
      }
      strong {
        font-size: 15px;
        margin-right: 5px;
      }
    }
    .forwardingOperation {
      float: right;
      margin-right: 30px;
      span {
        padding: 5px 20px;
        border: 1px solid #fff;
        border-radius: 17px;
      }
    }
    .operation {
      float: right;
      margin-top: 10px;
      &.operationBtn {
        margin-top: -8px;
      }
      div {
        cursor: pointer;
        border-radius: 17px;
        border: solid 1px #ffffff;
        padding: 3px 20px;
        margin-right: 10px;
      }
      & > div:last-child {
        margin-right: 25px;
      }
    }
  }
  .go-back {
    color: #fff;
    .iconfont {
      font-size: 22px;
    }
  }
  .handle-group {
    margin-top: 10px;
  }
  .btn-toggle {
    float: left;
    i {
      font-size: 12px;
      display: inline-block;
      transform: scale(0.5,0.5);
      margin-right: -2px;
    }
    span {
      display: block;
      padding: 0 5px 0 0;
      font-size: 11px;
      background: rgba(255,255,255,.35);
      line-height: 20px;
      border-radius: 10px;
    }
  }
  .btn-edit {
    font-size: 13px;
    line-height: 28px;
    padding: 0 20px;
    border-radius: 15px;
    border: 1px solid #fff;
    float: right;
    i {
      margin-right: 5px;
      display: inline-block;
    }
  }
  .header-bg {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    z-index: 1;
    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: 0.06;
    }
    &:before {
      width: 80px;
      height: 80px;
      border-radius: 0 80px 0 0;
      border-right: 30px solid #fff;
      border-top: 30px solid #fff;
    }
    &:after {
      width: 150px;
      height: 150px;
      border-radius: 0 150px 0 0;
      border-right: 30px solid #fff;
      border-top: 30px solid #fff;
    }
  }
  .content {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    //padding-top: 20px;
    width: 100%;
    margin-top: -10px;
    position: relative;
    z-index: 10;
    &.lookImgs {
      z-index: 12;
    }
  }
  .warehouse {
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    font-size: 13px;
    color: #4a4a4a;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
    .show-warehouse {

    }
   .view-header {
     position: relative;
     margin-bottom: 15px;
     h4 {
       font-size: 18px;
       font-weight: bold;
     }
     .btn-toggle {
       position: absolute;
       top: 0;
       right: 0;
       span {
         font-size: 13px;
       }
       i {
         transform: scale(.75,.75);
         margin-left: 5px;
       }
     }
   }
   .warehouse-box {
    width: 100%;
    margin: 0 auto 20px;
    border-radius: 4px;
    background: #fff;
    padding: 15px 0;
    font-size: 13px;
    color: #4a4a4a;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
   }
  }
  .warehouse-header {
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid rgba(101, 101, 101, 0.15);
    i {
      color: #e42029;
      margin-right: 5px;
      font-weight: normal;
    }
    h5 {
      font-size: 13px;
      font-weight: bold;
    }
    .col-5 {
      padding-right: 0;
      white-space: nowrap;
    }
    .col-7 {
      text-align: right;
    }
    .btn {
      height: 26px;
      border-radius: 13px;
      padding: 0 12px;
      line-height: 25px;
      font-size: 12px;
      & + .btn {
        margin-left: 10px;
      }
    }
  }
  .warehouse-content {
    padding: 0 20px;
    ul {
      padding: 0;
      list-style: none;
    }
    li {
      line-height: 2;
      span.dangerous {
        color: #e42029;
      }
    }
    .upload-img-list {
      word-break: break-all;
      margin: 0;
    }
    .lookImgs {
      cursor: pointer;
      text-decoration: underline;
      color: #e42029;
    }
  }
  .status-btn {
    padding: 0 20px;
    margin: 0;
    margin-top: 20px;
    div {
      width: 45%;
      cursor: pointer;
    }
    & > div:first-child {
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      border: solid 1px #979797;
      text-align: center;
      span {
        font-size: 15px;
        font-weight: 600;
        color: #929292;
      }
    }
    & > div:last-child {
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      background-image: linear-gradient(71deg, #f36443, #e42029);
      text-align: center;
      margin-left: 10%;
      span {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
      }
    }

  }
  .addWarehouse {
    width: 100%;
    background-image: linear-gradient(81deg, #f36443, #e42029);
    height: 46px;
    text-align: center;
    color: #fff;
    line-height: 46px;
    border-radius: 5px;
    margin-top: 20px;
    cursor: pointer;
    &.comfirmWarehouseBtn {
      width: 60%;
      margin: 20px auto 0;
    }
    i {
      font-size: 15px;
      margin-right: 5px;
    }
    span {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }
  }
  .visitor-list-wrapper {
    padding-top: 20px;
    margin-top: 0px;
    border-radius: 10px;
  }
}
.scrolled {
  .header:before,
  .header-bg {
    display: none;
  }
  .header {
    .title {
      margin-bottom: 0;
    }
  }
}
.operationDele {
  .header {
    padding-bottom: 10px;
  }
}
.show-popup,
.show-modal,
.show-status {
  height: 100vh;
  overflow: hidden;
  color: #4a4a4a;
  .reason,
  .tip {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);
    .tip-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 270px;
      border-radius: 12px;
      background-color: #fcfcfc;
      text-align: center;
      .tip-text {
        padding: 20px 0 15px;
        font-size: 17px;
        color: #4a4a4a;
      }
      .comfirmBtn {
       padding: 12px;
       font-size: 17px;
       color: #e42029;
      }
    }
    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
  }
  .reson-inner {
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    p {
      font-size: 13px;
      margin-bottom: 5px;
    }
    .reson-option {
      margin-bottom: 20px;
    }
    .refuse-reson {
      text-align: right;
      select {
        color: #929292;
        appearance: none;
        border: none;
        outline: none;
        padding-right: 9px;
        background: url('../../assets/images/arrow-copy.png') no-repeat right center;
        background-size: 7px;
      }
    }
    textarea {
      width: 100%;
      height: 175px;
      border: none;
      background: #f0f0f0;
      padding: 8px;
      font-size: 13px;
    }
    .form-group {
      margin-bottom: 25px;
    }
    .form-action {
      margin-bottom: 20px;
    }
    .btn {
      width: 100%;
    }
    .btn:hover {
     color: inherit;
    }
  }
}
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.visit-show {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  z-index: 15;
  background:rgba(0, 0, 0, 0.4);
  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

</style>
